// Userforms loads its own version of jQuery that we need to match
if (window.jQuery) {
  window.jQuery(document).ready($ => {
    /**
     * Override of Userform.jumpToStep to allow users to jump forward to any step for partial forms only
     * See vendor UserForms.js file for original function
     */
    function jumpToStepOverride(stepNumber, direction) {
      const targetStep = this.steps[stepNumber];
      const forward = typeof direction === "undefined" ? true : direction;

      // Make sure the target step exists.
      if (typeof targetStep === "undefined") {
        return;
      }

      // Make sure the step we're trying to set as current is not
      // hidden by custom display rules. If it is then jump to the next step.
      if (targetStep.conditionallyHidden()) {
        if (forward) {
          this.jumpToStep(stepNumber + 1);
        } else {
          this.jumpToStep(stepNumber - 1);
        }

        return;
      }

      // Set the 'valid' property on the current step.
      // Will catch errors on submission as we are disabling
      // validation on each step for partial forms
      this.currentStep.valid = this.$el.valid();

      this.currentStep.hide();
      this.setCurrentStep(targetStep);

      this.$el.trigger("userform.form.changestep", [targetStep.id]);
      $("html, body").scrollTop($("h1").offset().top);
    }

    /**
     * Override of Userform.validationOptions.submitHandler to ensure all steps have been validated
     * before submitting, this needs to be done as it is possible to submit without viewing each step
     * See vendor UserForms.js file for original function
     */
    function submitHandlerOverride(form) {
      let isValid = true;
      const userform = $(form)
        .closest(".userform")
        .data("inst");
      const finalStep = userform.currentStep;

      // Validate the current step
      if (userform.currentStep) {
        userform.currentStep.valid = $(form).valid();
      }

      // Check for invalid previous steps.
      $.each(userform.steps, (i, step) => {
        if (!step.valid && !step.conditionallyHidden()) {
          // If a step is invalid but hasn't been viewed, validate the step to prevent partial
          // forms from being submitted without being fully valid
          if (!step.viewed) {
            userform.currentStep.hide();
            userform.currentStep = step;
            userform.currentStep.show();
            userform.currentStep.valid = $(form).valid();

            if (!userform.currentStep.valid) {
              isValid = false;
              userform.errorContainer.addStepLink(step);
            }
          } else {
            isValid = false;
            userform.errorContainer.addStepLink(step);
          }
        }
      });

      // Show final step again after validating previous steps
      userform.currentStep.hide();
      userform.setCurrentStep(finalStep);

      if (isValid) {
        // When using the "are you sure?" plugin, ensure the form immediately submits.
        $(form).removeClass("dirty");

        form.submit();
      } else {
        userform.errorContainer.show();

        // If Validation has failed, reset the recaptcha to prevent a bug where the submitHandler does not fire again
        if (window.grecaptcha) {
          window.grecaptcha.reset();
        }
      }
    }

    // Update aria-label instead of text as we hide the text for step-navigation
    $(".userform").on(
      "userform.form.conditionalstep",
      function conditionalStepChange() {
        const $visibleButtons = $(this).find(".step-button-jump:visible");

        $visibleButtons.each((i, button) => {
          $(button)
            .text("")
            .attr("aria-label", `Step ${i + 1}`);
        });
      }
    );

    const $saveButton = $(".userform .step-button-save");

    // If the page has a "save" button, then the form is partial
    if (!$saveButton.length) {
      return;
    }

    const $userform = $saveButton.closest(".userform");
    const userformInstance = $userform.data("inst");
    const validator = $userform.data("validator");
    userformInstance.jumpToStep = jumpToStepOverride;
    validator.settings.submitHandler = submitHandlerOverride;

    $userform.find(".step-button-jump").each((index, el) => {
      $(el).removeAttr("disabled");
    });
  });
}
